import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "f-tabs" }
const _hoisted_2 = { class: "f-tabs__header f-hide-scrollbar py-2 px-4 bg-white text-gray-500" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabPanes, (tabPane) => {
        return (_openBlock(), _createElementBlock("span", {
          key: tabPane.tab,
          class: _normalizeClass(["f-tabs__tab", { 'f-tabs__tab--active': tabPane.tab === _ctx.modelValue }]),
          onClick: ($event: any) => (_ctx.handleClickTab(tabPane.tab))
        }, _toDisplayString(tabPane.name || tabPane.tab), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", {
      ref: "scrollContent",
      class: "f-hide-scrollbar flex-auto flex overflow-x-auto flex-nowrap items-stretch",
      style: {"scroll-snap-type":"x mandatory"},
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleContentScroll && _ctx.handleContentScroll(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 544)
  ]))
}